import classes from './Background.module.css';

const Background = () => {
  return (
    <div className={classes.back}>
      <div className={classes.middle}>
        <div className={classes.front} />
      </div>
    </div>
  );
};

export default Background;
